import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import VendorCertificateImage from './VendorCertificateImage';

/**
 * Правая колонка страницы решения: сертификат вендора сверху, затем новость.
 */
const ProductNewsSidebar = ({ certificateUrl, vendorName, featuredNews }) => {
  const certVendor = certificateUrl
    ? { name: vendorName, certificate: certificateUrl }
    : null;
  if (!certVendor && !featuredNews) return null;

  return (
    <div className="animate-slide-up space-y-4" style={{ animationDelay: '80ms' }}>
      {certVendor ? (
        <VendorCertificateImage vendor={certVendor} className="w-full aspect-[4/3] max-h-56" />
      ) : null}
      {featuredNews ? (
        <>
          <h3 className="text-3xl font-semibold mb-4">Новости</h3>
          <Link to={featuredNews.href} className="block group">
            <Card className="bg-card border-border/50 shadow-sm overflow-hidden hover:border-accent/40 transition-colors">
              {featuredNews.image ? (
                <img
                  src={featuredNews.image}
                  alt={featuredNews.title}
                  className="w-full h-40 object-cover"
                />
              ) : null}
              <CardContent className="p-4 space-y-2">
                <div className="text-xs text-muted-foreground">
                  {featuredNews.category}
                  {featuredNews.date ? ` • ${featuredNews.date}` : ''}
                </div>
                <div className="font-medium leading-snug group-hover:text-accent transition-colors">
                  {featuredNews.title}
                </div>
              </CardContent>
            </Card>
          </Link>
        </>
      ) : null}
    </div>
  );
};

export default ProductNewsSidebar;
